import type { TFunction } from 'i18next'
import type { UserLinkCopy } from 'ComponentLibrary/src/piazza/text/UserLink/UserLink'
import type { HeaderObserversCopy } from 'ComponentLibrary/src/widgets/Observers/HeaderObservers'
import type { ObserversDrawerCopy } from 'ComponentLibrary/src/widgets/Observers/ObserversDrawer'

export const getHeaderBarUserLinkCopy = (tHeaderBar: TFunction): UserLinkCopy => ({
    me: tHeaderBar('userLink.me'),
    external: tHeaderBar('userLink.external'),
    unknown: tHeaderBar('userLink.unknown'),
    unavailable: tHeaderBar('userLink.unavailable'),
    contact: tHeaderBar('userLink.contact'),
    editOwnContactTooltip: tHeaderBar('userLink.editOwnContactTooltip'),
    emailCopied: tHeaderBar('userLink.emailCopied'),
    phoneCopied: tHeaderBar('userLink.phoneCopied'),
    addressCopied: tHeaderBar('userLink.addressCopied'),
    note: tHeaderBar('userLink.note'),
    externalEmailInfo: tHeaderBar('userLink.externalEmailInfo'),
})

export const getHeaderObserversCopy = (tHeaderBar: TFunction): HeaderObserversCopy => ({
    protectedTooltip: tHeaderBar('observers.header.protectedTooltip'),
    platformUserTooltip: tHeaderBar('observers.header.platformUserTooltip'),
    observingTooltip: tHeaderBar('observers.header.observingTooltip'),
    notObservingTooltip: tHeaderBar('observers.header.notObservingTooltip'),
    addObserverTooltip: tHeaderBar('observers.header.addObserverTooltip'),
    observerGroup: tHeaderBar('observers.header.observerGroup'),
    disableObservationAriaLabel: tHeaderBar('observers.header.disableObservationAriaLabel'),
    enableObservationAriaLabel: tHeaderBar('observers.header.enableObservationAriaLabel'),
})

export const getObserversDrawerCopy = (tHeaderBar: TFunction): ObserversDrawerCopy => ({
    title: tHeaderBar('observers.drawer.title'),
    addObserversLabel: tHeaderBar('observers.drawer.addObserversLabel'),
    observeOrder: tHeaderBar('observers.drawer.observeOrder'),
    observerCount: (count: number) => tHeaderBar('observers.drawer.observerCount', { count }),
    editObservers: tHeaderBar('observers.drawer.editObservers'),
    responsible: tHeaderBar('observers.drawer.responsible'),
    responsibleRemoveTooltip: tHeaderBar('observers.drawer.responsibleRemoveTooltip'),
    infoTitle: tHeaderBar('observers.drawer.infoTitle'),
    infoText: tHeaderBar('observers.drawer.infoText'),
    notificationSettings: tHeaderBar('observers.drawer.notificationSettings'),
})
